import {connect} from 'react-redux';
import ReduxState from '../../types/ReduxState';
import ReviewModel from '../../types/ReviewModel';
import SimpleReviewerModel from '../../types/SimpleReviewerModel';
import ShareReviewModal, {ShareReviewModalProps} from './ShareReviewModal';
import Themeable from '../../types/Themeable';
import {ModalStates} from '../../globals/Constants';
import ModalEventHandlersModel from '../../types/ModalEventHandlers';
import {History} from 'history';

const mapStateToProps = (state: ReduxState, ownProps: ShareReviewModalContainerProps): Partial<ShareReviewModalProps> => {
   return {
      history: ownProps.history,
      themeName: state.themeName,
      reviewers: ownProps.reviewers,
      isOwner: ownProps.isOwner,
      review: state.currentReview as ReviewModel,
      showReviewCreated: ownProps.showReviewCreated,
      onClose: ownProps.onClose,
      setModalState: ownProps.setModalState,
      currentUserId: state.currentUserId || null
   };
};

export default connect(mapStateToProps)(ShareReviewModal);

interface ShareReviewModalContainerProps extends Themeable {
   reviewers: SimpleReviewerModel[];
   isOwner: boolean;
   showReviewCreated?: boolean;
   history: History;
   onClose(): void;
   setModalState(modalState: ModalStates, modalEventHandlersModel: ModalEventHandlersModel): void;
}
